/**
 * Determines if something should be shown based on environment and options.
 * @param {Object} options
 * @param {boolean} options.showInProd - Show in production web? (required)
 * @param {boolean} options.showInDev - Show in development web? (required)
 * @param {boolean} options.showInMobileProd - Show in production mobile? (required)
 * @param {boolean} options.showInMobileDev - Show in development mobile? (required)
 *
 * Logic summary: isDevelopment=true (Deployed to DEV) or isDevelopment=false (Deployed to Prod)
 * Web:
 *   isDevelopment=true, showInDev=false → returns false
 *   isDevelopment=true, showInDev=true → returns true
 *   isDevelopment=false, showInProd=false → returns false
 *   isDevelopment=false, showInProd=true → returns true
 *   In web, showInProd is ignored in dev, showInDev is ignored in prod.
 * Mobile:
 *   isEmbeddedMobile=true, isDevelopment=false, showInMobileProd=true → returns true
 *   isEmbeddedMobile=true, isDevelopment=false, showInMobileProd=false → returns false
 *   isEmbeddedMobile=true, isDevelopment=true, showInMobileDev=true → returns true
 *   isEmbeddedMobile=true, isDevelopment=true, showInMobileDev=false → returns false
 *   In mobile, only the relevant mobile flag is checked
 */

function hasPermissionByEnv({
  showInProd,
  showInDev,
  showInMobileProd,
  showInMobileDev,
}: {
  showInProd: boolean;
  showInDev: boolean;
  showInMobileProd: boolean;
  showInMobileDev: boolean;
}) {
  const isDevelopment = window.Ohs?.Env?.isDevelopment;
  const isEmbeddedMobile = window.Ohs?.Env?.isEmbeddedMobile;

  // Mobile
  if (isEmbeddedMobile === true) {
    if (isDevelopment === true) {
      return showInMobileDev === true;
    }
    return showInMobileProd === true;
  }

  // Web
  if (isDevelopment === true) {
    return showInDev === true;
  }
  return showInProd === true;
}

const OhsEnvUtils = {
  hasPermissionByEnv,
};

export default OhsEnvUtils;
